import { carouselData } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section
      id="carousel"
      className="py-14 md:py-20 px-4 md:px-6 bg-background-50"
    >
      <div className="w-full max-w-[1280px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-4">
          精选专题推荐
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8">
          编辑精选高分漫画，每一部都值得从头追到尾
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {carouselData.map((item) => (
            <div
              key={item.title}
              className="group relative rounded-2xl overflow-hidden bg-background-100 border border-background-200/70 cursor-pointer transition-all duration-300 hover:border-primary-200"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-background-50/90 backdrop-blur-sm rounded-full text-xs text-foreground-700 font-medium">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-lg text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.summary}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}